import { QueryFeature } from '../../../config/queryClient';

export const queryKeys = {
  dashboard: () => [QueryFeature.Dashboard],
};
